<template>
    <div>
      
               <div class="form-row position-relative">
           
            
            <label class="col-11 col-form-label d-relative" :for="value.webSiteId">
                 <editable-label :label="value.label" @update-label="upddateLabel" :index="index" defaultLabel="Indirizzo web"  :readOnly="readOnly || value.isImported" :first="index==0"></editable-label>
            </label>
              <div class="col-1">
                <div class="dropdown" v-if="!readOnly">
                  <button
                    class="btn btn-link l-h-20 p-0 font-18 float-right"
                    type="button"
                    id="CustomdropdownMenuButton8"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <i class="feather icon-more-horizontal-"></i>
                  </button>
                  <div
                    class="dropdown-menu dropdown-menu-right"
                    aria-labelledby="CustomdropdownMenuButton8"
                  >
                    <a class="dropdown-item font-13 nav-link" v-on:click.stop="add" ><i class="feather icon-plus"></i> Aggiungi Indirizzo</a>
               
                    <a class="dropdown-item font-13 text-danger cursor-pointer nav-link"  v-on:click.stop="remove"  v-if="!first && !value.isImported && !readOnly"><i class="feather icon-trash"></i> Elimina</a>
                  </div>
                </div>
            </div>
            <div class="col">
             
                    <input type="text" :id="value.webSiteId"  v-if="!readOnly && !value.isImported" :name="value.webSiteId" placeholder="Numero di webSite" v-model="value.webSiteNumber" class="form-control" >
               
                 <span v-if="readOnly || value.isImported">
                    {{value.url}}
                </span>
              
            </div>
        </div>
           
          
        </div>

       

</template>
<script>

export default {
        name: 'webSite',
       
        props: {
            readOnly: {
                type: Boolean,
                required: false,
                default:() => false
            },
             last: {
                type: Boolean,
                required: true,
                default:() => false
            },
              first: {
                type: Boolean,
                required: false,
                default:() => false
            },
            value: {
                type: Object,
                required: false,
                
            },
            index: {
                type: Number,
                required: false,
                default:()=>0
            }
        },
      
        components: {
           
        },
        data() {
            return {
                hover:false
            }
        },
        methods: {
            
         
            upddateLabel: function (label) {
                this.value.label = label;
            }
           
             , remove: function () {
                this.$emit('remove-entity', this.value)
            }

              , add: function () {
               
               
                 this.$emit('add-entity')
            }
            
        }
}
</script>

<style lang="css">
  .nav-link {
    cursor:pointer;
  }
</style>
